export const ACK_PAGE = 'ACKNOWLEDGEMENT_PAGE';
export const PAYMENT_SAFE_PAGE = 'PAYMENT_SAFE_PAGE';
export const SME_SEGMENT = 'B';
export const CREDIT_CARD = 'credit_card';
export const TO_ACCOUNT = 'toAccount';
export const FROM_ACCOUNT = 'fromAccount';

export const OUTCOME_TYPE = {
	STATIC: 'static',
	DYNAMIC: 'dynamic',
};
export const PaymentType = {
	FPS: 'FASTERPAYMENTS',
	BATCH_FPS: 'BATCHFPS',
	LIST_FPS: 'LISTFPS',
	CHAPS: 'CHAPS',
	BATCH_CHAPS: 'BATCHCHAPS',
	LIST_CHAPS: 'LISTCHAPS',
	BACS_CREDIT: 'BACSCREDIT',
};

export const NextStep = {
	PROCEED: 'PROCEED',
	ACKNOWLEDGEMENT: 'ACKNOWLEDGEMENT',
	CONTINUE_TO_PAYMENT: 'CONTINUETOPAYMENT',
};

export const staticWarningPaymentTypes = [
	PaymentType.BATCH_FPS,
	PaymentType.BATCH_CHAPS,
	PaymentType.LIST_FPS,
	PaymentType.LIST_CHAPS,
];

export const retailPaymentTypes = {
	single: 'One-off payment',
	repeating: 'repeating',
};

export const errorType = {
	REASON: 'paymentReasonsError',
	CREATE: 'createEffectiveWarning',
	UPDATE_ACK: 'updateAcknowledgement',
};

export const frequencyKeyValues = {
	'1 weekly': 'Every week',
	'2 weekly': 'Every 2 weeks',
	'3 weekly': 'Every 3 weeks',
	'4 weekly': 'Every 4 weeks',
	'1 monthly': 'Every month',
	'2 monthly': 'Every 2 months',
	'3 monthly': 'Every 3 months',
	'6 monthly': 'Every 6 months',
	'12 monthly': 'Every year',
};

export const CustomerType = {
	BUSINESS: 'business',
	RETAIL: 'retail',
};

export const CustomerJourney = {
	CREATE: 'create',
	APPROVAL: 'approval',
};

export const declarationWebLink = {
	B: 'https://uk.virginmoney.com/virgin/service/staying-safe-online/',
	VM: 'https://uk.virginmoney.com/virgin/service/staying-safe-online/learn-about-different-types-of-fraud/',
	CB: 'https://secure.cbonline.co.uk/personal/ways-of-banking/help-and-support/security/',
	YB: 'https://secure.ybonline.co.uk/personal/ways-of-banking/help-and-support/security/',
};

export const IBActions = {
	CANCEL_PAYMENT: 'CANCEL_PAYMENT',
	ON_REVIEW: 'ON_REVIEW',
	CLEAR_MODAL_CONFIG: 'CLEAR_MODAL_CONFIG',
	ON_PAYMENT_GUIDANCE: 'ON_PAYMENT_GUIDANCE',
	ERROR: 'ERROR',
};
